/*
 * CkEditor 5 Initializer
 */
import md5 from 'md5'

declare global {
    interface Window {
        Esearcher: any
    }
}

const CkEditor5Initializer = (editor: any, editorConfigurationName: string = 'small') => {

    const init = (el: Element) => {
        /*
         * Check if a CkEditor 5 is either being initialized or has been initialized
         * on the el element. If so, abort.
         */
        const attributeInitializationPhase = 'data-ckeditor5-initialization-phase'
        const editorInitializationPhase = el.getAttribute(attributeInitializationPhase)

        if (editorInitializationPhase === 'initializing' || editorInitializationPhase === 'completed') return

        /*
         * We need to set the initialization completed to true before the editor is instantiated
         * because its instantiation is asynchronous, i.e. a (second) call to initialize an editor
         * on the same element can arrive before the first call is handled.
         */
        el.setAttribute(attributeInitializationPhase, 'initializing')

        /*
         * CkEditor 5 has no Global List of Editor Instances, so we create one of ourselves.
         */
        if (window.Esearcher === undefined) window.Esearcher = {}
        if (window.Esearcher.ckeditor5 === undefined) window.Esearcher.ckeditor5 = {}

        return editor(editorConfigurationName)
            .init(el)
            .then(editor => {
                const attributeName = el.getAttribute('name')
                const attributeId = el.getAttribute('id')

                let editorKey = 'default'
                attributeName ? editorKey = attributeName : null
                attributeId ? editorKey = attributeId : null

                window.Esearcher.ckeditor5[editorKey] = editor

                el.getAttribute('data-ckeditor5-readonly') === 'true' ?
                    editor.enableReadOnlyMode('lock-id-' + editorKey) :
                    null

                /*
                 * The content of the textarea(s) which is set in the backend PHP code
                 * is sometimes modified by the CkEditor 5 on the initial render.
                 * This invalidates the hash calculated in the backend PHP code,
                 * to remedy this we take the current content, recalculate the hash
                 * and replace the value of the data-hash attribute.
                 */
                el.setAttribute('data-hash', md5(editor.getData()))

                /*
                 * Compatibility:
                 * If there is a change in data of an editor, update
                 * the editor base element value and trigger a jQuery change event on it.
                 */
                editor.model.document.on('change:data', () => {
                    $(el).text(editor.getData())
                    $(el).trigger('change')
                })

                el.setAttribute(attributeInitializationPhase, 'completed')

                $(el).trigger('ckeditor5-initialization-complete');
            })
    }

    const initAll = (selector: string = '.ckeditor5') => {
        const elements = document.querySelectorAll(selector)

        if (elements.length === 0) return

        const promisesEditor: Promise<any>[] = []
        for (const element of elements) {
            promisesEditor.push(init(element))
        }

        Promise.all(promisesEditor).then(
            () => $(document).trigger('ckeditor5-reinitialization-complete')
        )
    }

    return {
        initAll
    }
}

export {
    CkEditor5Initializer
}
